if (!customElements.get('product-description-tabs')) {
    class ProductDescriptionTabs extends HTMLElement {

        constructor() {
            super();
            this.boundHandleClick = this.handleClick.bind(this);
            // Will need to collect the bound keystrokes here so that we can properly remove them later
            this.boundHandleKeystrokes = [];
            this.tabs = this.querySelectorAll('.product-description__tab');
            this.tabsContents = this.querySelectorAll('.product-description__tab-content');
            this.tablist = this.querySelector('.product-description__tabs');
            this.tabsA = this.querySelectorAll('a');
            this.panels = this.querySelectorAll('.product-description__tab-content');
        }

        connectedCallback() {
            this.setTabHandling();
            this.setTabAccessibility();
        }

        disconnectedCallback() {
            this.tabsA.forEach((tab, i) => {
                tab.removeEventListener('click', this.boundHandleClick);
                tab.removeEventListener('keydown', this.boundHandleKeystrokes[i]);
            });
        }

        setTabAccessibility() {
            this.tablist.setAttribute('role', 'tablist');

            this.tabsA.forEach((tab, i) => {
                tab.addEventListener('click', this.boundHandleClick);
                // e object is implicitly passed here with the event trigger
                const boundHandler = this.handleKeystrokes.bind(this, i);
                tab.addEventListener('keydown', boundHandler);
                // pushing to array so that we can properly remove it in the disconnectedCallback
                this.boundHandleKeystrokes.push(boundHandler);
            });

            this.panels.forEach((panel, i) => {
                this.updatePanelAccessibility(i, panel);
            });

            this.tabsA[0].removeAttribute('tabindex');
            this.tabsA[0].setAttribute('aria-selected', 'true');
            this.panels[0].hidden = false;
        }

        setTabHandling() {
            this.tabs.forEach(tab => {
                tab.addEventListener('click', () => this.setTabListener(tab));
            });
        }

        setTabListener(tab) {
            const contentId = tab.dataset.contentId;
            const content = document.getElementById(contentId);

            this.tabsContents.forEach(function (content) {
                content.classList.remove('active');
            });

            this.tabs.forEach(function (tab) {
                tab.classList.remove('active');
            })

            content.classList.add('active');
            tab.classList.add('active');
        }

        switchTab(oldTab, newTab) {
            newTab.focus();
            newTab.parentNode.classList.add('active');
            newTab.setAttribute('aria-selected', 'true');

            oldTab.removeAttribute('aria-selected');
            oldTab.parentNode.classList.remove('active');

            const index =  Array.from(this.tabsA).indexOf(newTab);
            const oldIndex = Array.from(this.tabsA).indexOf(oldTab);
            this.panels[oldIndex].hidden = true;
            this.panels[index].hidden = false;
            this.panels[oldIndex].parentNode.classList.remove('active');
            this.panels[index].parentNode.classList.add('active');
        }

        handleClick(e) {
            e.preventDefault();
            const currentTab = this.tablist.querySelector('[aria-selected]');
            if (e.currentTarget !== currentTab) {
                this.switchTab(currentTab, e.currentTarget);
            }
        }

        handleKeystrokes(i, e) {
            // Get the index of the current tab in the tabs node list
            const index = Array.from(this.tabsA).indexOf(e.currentTarget);
            // Work out which key the user is pressing and
            // Calculate the new tab's index where appropriate
            let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
            if (dir !== null) {
                e.preventDefault();
                // If the down key is pressed, move focus to the open panel,
                // otherwise switch to the adjacent tab
                dir === 'down' ? this.panels[i].focus() : this.tabsA[dir] ? this.switchTab(e.currentTarget, this.tabsA[dir]) : void 0;
            }
        }

        updatePanelAccessibility(i, panel) {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('tabindex', '-1');
            panel.setAttribute('aria-labelledby', this.tabsA[i].id);
            panel.hidden = true;
        }
    }

    customElements.define('product-description-tabs', ProductDescriptionTabs);
}
